import React from "react";
import GlobalSearchService from "../components/admin/services/GlobalSearchService";
import AdminClient from "../components/admin/client/AdminClient";

function useDataFetchers(session, dataType=null, btFirmsStage=null) {
    const titles = (query) => {
        return GlobalSearchService.titles(query, session)
    }
    const investors = (query) => {
        return GlobalSearchService.investors(query, session, dataType)
    }
    const riaInvestors = (query) => {
        return GlobalSearchService.riaInvestors(query, session)
    }

    const achievements = (query) => {
        return GlobalSearchService.achievements(query, session)
    }

    const foContacts = (query) => {
        return GlobalSearchService.fo_contacts(query, session)
    }

    const riaContacts = (query) => {
        return GlobalSearchService.contacts(query, session)
    }
    const investorDrafts = (query) => {
        return GlobalSearchService.investorDrafts(query, session)
    }
    const companies = (query) => {
        return GlobalSearchService.companies(query, session)
    }
    const foCompaniesForAffinity = (query) => {
        return GlobalSearchService.foCompaniesForAffinity(query, session)
    }
    const universities = (query) => {
        return GlobalSearchService.universities(query, session)
    }
    const responsibilities = (query, dataset="FO") => {
        return GlobalSearchService.responsibilities(query, session, dataset)
    }
    const servicesProvided = (query, dataset="BT") => {
        return GlobalSearchService.servicesProvided(query, session, dataset)
    }
    const researchers = (query) => {
        return GlobalSearchService.researchers(query, session)
    }
    const activeResearchers = (query) => {
        return GlobalSearchService.activeResearchers(query, session)
    }
    const pwtResearchers = (query) => {
        return GlobalSearchService.researchers(query, session, "pwt")
    }
    const pwtActiveResearchers = (query) => {
        return GlobalSearchService.activeResearchers(query, session, "pwt")
    }
    const addressResearchers = (query) => {
        return GlobalSearchService.researchers(query, session)
    }
    const addressActiveResearchers = (query) => {
        return GlobalSearchService.activeResearchers(query, session)
    }
    const stages = (query) => {
        return GlobalSearchService.stages(query, session)
    }
    const btStages = (query) => {
        return GlobalSearchService.btStages(query, session)
    }
    const familyWealthOrigins = (query) => {
        return GlobalSearchService.familyWealthOrigins(query, session)
    }
    const cities = (query) => {
        return GlobalSearchService.cities(query, session)
    }
    const riaCities = (query) => {
        return GlobalSearchService.riaCities(query, session)
    }
    const riaCountries = (query) => {
        return GlobalSearchService.riaCountries(query, session)
    }
    const investorTypes = (query) => {
        return GlobalSearchService.investorTypes(query, session)
    }
    const fundedCompanies = (query) => {
        return GlobalSearchService.fundedCompanies(query, session)
    }
    const fundedProperties = async (query) => {
        return await GlobalSearchService.fundedProperties(query, session)
    }
    const publishers = (query) => {
        return GlobalSearchService.publishers(query, session)
    }
    const hobbies = (query) => {
        return GlobalSearchService.hobbies(query, session)
    }
    const btFirms = (query) => {
        return GlobalSearchService.btFirmsForContactWork(query, session, btFirmsStage || 'published')
    }

    const foundationsFirms = (query) => {
        return GlobalSearchService.foundationsFirms(query, session, "")
    }
    const allFirms = (query, entityCategory) => {
        return GlobalSearchService.allFirms(query, session, entityCategory)
    }
    const pwtServices = (query) => {
        return GlobalSearchService.pwtServices(query, session)
    }

    const privateWealthTeams = (query) => {
        return GlobalSearchService.privateWealthTeams(query, session)
    }
    const efFirms = (query) => {
        return GlobalSearchService.foundations(query, session)
    }

    const efContacts = (query) => {
        return GlobalSearchService.efContacts(query, session)
    }
    const btResearchers = (query) => {
        return GlobalSearchService.researchers(query, session, "bt")
    }

    const bankTrust = (query, stage='published') => {
        return GlobalSearchService.bankTrust(query, session, stage)
    }

const btContact = (query) => {
  return GlobalSearchService.btContact(query, session)
}

    const btBranchOffices = (bankTrustId) => (query) => {
        return GlobalSearchService.btBranchOffices(bankTrustId, query, session)
    }

    const foundationSectors = (query) => {
        return GlobalSearchService.foundationSectors(query, session)
    }
    const foundationSubSectors = (query) => {
        return GlobalSearchService.foundationSubSectors(query, session)
    }
    const foundationStages = (query) => {
        return GlobalSearchService.foundationStages(query, session)
    }
    const foundationAttachments = (query) => {
        return GlobalSearchService.foundationAttachments(query, session)
    }
    const foundationConsultants = (query) => {
        return GlobalSearchService.foundationConsultants(query, session)
    }

    const pwtTypes = () => {
        return GlobalSearchService.pwtTypes(session)
    }

    const maTransactions = (query) => {
        return GlobalSearchService.maTransactions(query, session)
    }

    const riaInvestorsMA = (query) => {
        return GlobalSearchService.riaInvestorsMA(query, session)
    }

    return {
        titles,
        investors,
        riaInvestors,
        achievements,
        investorDrafts,
        companies,
        foCompaniesForAffinity,
        universities,
        responsibilities,
        researchers,
        activeResearchers,
        pwtResearchers,
        pwtActiveResearchers,
        stages,
        familyWealthOrigins,
        cities,
        foContacts,
        riaContacts,
        riaCities,
        riaCountries,
        investorTypes,
        fundedCompanies,
        fundedProperties,
        publishers,
        hobbies,
        btFirms,
        privateWealthTeams,
        pwtServices,
        pwtTypes,
        efFirms,
        efContacts,
        bankTrust,
        btContact,
        btBranchOffices,
        foundationsFirms,
        allFirms,
        foundationSectors,
        foundationSubSectors,
        foundationStages,
        foundationAttachments,
        foundationConsultants,
        addressResearchers,
        addressActiveResearchers,
        maTransactions,
        riaInvestorsMA,
        btStages,
        btResearchers,
        servicesProvided,
    }
}

export default useDataFetchers;